<template>
  <div class="grid-x align-center padding-top-xl padding-bottom-m">
    <div class="cell large-6 grid-y">
      <ReviewSuccessfullySubmitted v-if="isCurrentProductReviewed" data-test-id="review-successfully-submitted" />
      <WriteReviewComponent v-else-if="isMounted" data-test-id="write-review-component" />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useMounted } from '@vueuse/core';
import useProductStore from '~/stores/useProductStore';
import useConsolidatedMemberStore from '~/stores/useConsolidatedMemberStore';
import { useLoyaltyProvide } from '~/composables/loyalty/useLoyalty';
import WriteReviewComponent from '~/modules/reviews/components/writeReview/WriteReviewComponent';
import ReviewSuccessfullySubmitted from '~/modules/reviews/components/writeReview/ReviewSuccessfullySubmitted';
import { useUserProvide } from '~/composables/user/useUser';
import useWriteReview from '~/modules/reviews/composables/useWriteReview';
import { useProductProvide } from '~/modules/product/composables/useProductProvide';
import fireViewTag from '~/features/analytics/viewManager';
import { useImagesProvide } from '~/composables/images/useImages';
import { useProductPriceProvide } from '~/modules/price/composables/useProductPriceProvide';
import useReviews from '~/modules/reviews/composables/useReviews';
import { useConsolidatedMemberProvide } from '~/composables/useConsolidatedMember';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

const productStore = useProductStore();
const consolidatedMemberStore = useConsolidatedMemberStore();

const product = consolidatedMemberStore.memberProduct || productStore.product;
const productId = consolidatedMemberStore.selectedMember || productStore.product.id;

useUserProvide();
useLoyaltyProvide();
useProductProvide(productId, product);
const { isShopTheSetExpEnabled } = useFeatureEligibility();
if (isShopTheSetExpEnabled) {
  useConsolidatedMemberProvide();
}
useProductPriceProvide({ id: productId, product });
useImagesProvide();

const { updateIsCurrentProductReviewed, isCurrentProductReviewed } = useWriteReview();

if (import.meta.server && product) {
  const reviewsStore = useReviews();
  reviewsStore.initReviewsContext({
    product,
    activeReviewProductId: productId,
    members: productStore.getAllMembers,
  });
  reviewsStore.initReviews();
}

const isMounted = useMounted();

onMounted(() => {
  updateIsCurrentProductReviewed();
  fireViewTag({ writeReviewPage: true });
});
</script>
